
import { destroy, get, getOne, post, put } from "../apis/httpClient"

export const pagingContact=(params)=>get('/api/v1/contact/paging',params)
export const detailContact=(query)=>getOne(`/api/v1/contact/detail/${query}`)
export const deleteContact=(body)=>destroy(`/api/v1/contact/delete`,body)
